import React from 'react';

export const VisruptLogo = ({ className }: { className?: string }) => (
  <svg 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 810 810"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#bf6888ab30)">
      <path 
        fill="#60a5fa" 
        d="M786.793 53.238s-14.238 101.946-103.797 174.602c-50.496 40.96-95.371 61.445-160.82 74.715-15.207 3.082-30.504 5.535-45.863 7.398l-.02.024-25.605 67.715-.035.001L328.992 699.492h152.574l111.383-310.316c56.23-20.293 102.863-50.48 139.347-90.578 96.192-105.739 55.032-239.704 54.497-245.36"
      />
    </g>
    <g clipPath="url(#d8a4a13eaa)">
      <path 
        fill="#3b82f6" 
        d="M23.191 53.238s14.235 101.946 103.797 174.602c50.496 40.96 95.363 61.445 160.82 74.715 15.2 3.082 30.504 5.535 45.863 7.398l.02.024 25.605 67.715.035.001 121.652 321.8h-152.574L217.035 389.176c-56.23-20.293-102.863-50.48-139.347-90.578C-18.504 192.859 22.656 58.894 23.191 53.238"
      />
    </g>
    <defs>
      <clipPath id="bf6888ab30">
        <path d="M328 53.242h467.992V699.5H328z"/>
      </clipPath>
      <clipPath id="d8a4a13eaa">
        <path d="M13.984 53.242H481V699.5H13.984z"/>
      </clipPath>
    </defs>
  </svg>
);